import React from 'react';
import Navebar from '../Navebar/Navebar';

const Blog = () => {
    return (
        <div className='min-h-[100vh]'>
            <Navebar/>
            <h1 className="text-2xl text-center text-red-400 my-20">Blog Coming Soon !</h1>
        </div>
    );
};

export default Blog;